import { render, staticRenderFns } from "./DispatchSlideReleaseConfirmDialog.vue?vue&type=template&id=06085ed0&lang=pug"
import script from "./DispatchSlideReleaseConfirmDialog.vue?vue&type=script&lang=js"
export * from "./DispatchSlideReleaseConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports